import Title from "./Title";
import img1 from '../img/feature1.png';
import img2 from '../img/feature2.png';
import img3 from '../img/feature3.png';
export default function Features() {
    const features = [ 
        {
            img: img1,
            title: "monitor Moving & Packing transactions easily",
            text: "You can monitor your Moving & Packing money transactions either into the bank or out of the bank."
        },
        {
            img: img2,
            title: "You can Track your Moving & Order analysis",
            text: "Analyze finances whether it is wasteful or not with the contest analysis feature."
        },
        {
            img: img3,
            title: "various payment options available",
            text: "Various Payment Options & Support over 10+ barriers, You don't have to worry about Payments. ​​"
        }
    ]

    return <>
        <div className="features mt-4 mb-md-4">
            <div className="container" >
                <Title mainClass="m-auto d-table mb-3 mb-md-5"
                    titleclass="lg text-dark text-center mb-1"
                    desclass="mt-2   text-center mb-2"
                    title={<>Features that you can get <br></br>
                        in ExquisiteMoves!</>}
                    des="Our goal is to tailor each experience to specifically fit all moving needs."
                />
                <div className="row featuresBox" >
                    {features.map((m, i) => {
                        return <>
                            <div key={i} className="col-md-4 text-center mb-4" >
                                <img src={m.img} alt="image" className="img-fluid" />
                                <h2>{m.title}</h2>
                                <p>{m.text}</p>
                            </div>
                        </>
                    })}
                </div>
            </div>
        </div>
    </>
}
